import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import {
  faCogs,
  faDesktop,
  faListUl,
  faSignOutAlt,
  faTasks
} from "@fortawesome/free-solid-svg-icons";

const items = {
  home: {
    title: "홈",
    icon: faCalendarAlt,
    path: "/m/mainview/home"
  },
  approval: {
    title: "결재 처리 조회",
    icon: faTasks,
    path: "/m/mainview/approval",
    backgroundColor: "#3D81E7"
  },
  request: {
    title: "결재 신청 조회",
    icon: faListUl,
    path: "/m/mainview/request",
    backgroundColor: "#55BF8C"
  },
  settings: {
    title: "환경 설정",
    icon: faCogs,
    path: "/m/mainview/settings",
    backgroundColor: "#cc6262"
  },
  logOut: {
    title: "로그아웃",
    redirect: "/",
    icon: faSignOutAlt,
    path: "/mainview/logout"
  },
  des: {
    title: "데스크탑모드",
    icon: faDesktop,
    path: "/mainview/desktop"
  }
};

export default items;
